/**
 * Tiskový štítek na balík – při window.print() se přes @media print
 * (vratky.css) vytiskne pouze tento blok. Náhrada react-to-print.
 */

const LABEL_BY_LANG: Record<string, { VRATKA: string; REKLAMACE: string }> = {
    en: { VRATKA: 'RETURN', REKLAMACE: 'CLAIM' },
    fr: { VRATKA: 'RETOUR', REKLAMACE: 'RECLAMATION' },
    de: { VRATKA: 'RÜCKSENDUNG', REKLAMACE: 'REKLAMATION' },
    nl: { VRATKA: 'RETOUR', REKLAMACE: 'KLACHT' },
    it: { VRATKA: 'RESO', REKLAMACE: 'RECLAMO' },
};

/** 'VRATKA 12345' -> 'RETURN 12345' podle jazyka mutace (cs/sk beze změny) */
export function translateLabel(stitekInfo: string, language: string): string {
    const map = LABEL_BY_LANG[language];
    if (!map) {
        return stitekInfo;
    }

    return stitekInfo.replace('VRATKA', map.VRATKA).replace('REKLAMACE', map.REKLAMACE);
}

export function PrintLabel({ stitekInfo }: { stitekInfo: string }) {
    return (
        <div className="vr-print-label">
            BOLA spol s.r.o.<br />
            Severní 276<br />
            252 25 Jinočany<br />
            Czech Republic<br />
            <br />
            {stitekInfo}
        </div>
    );
}
